"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnyObjectSchema = exports.AnySchema = void 0;
const schema_1 = require("../schema");
const schema_type_1 = require("../schema-type");
class AnySchema extends schema_1.Schema {
    constructor(description, objectInitializer) {
        super("any", description, schema_type_1.SchemaType.Any);
        this.apply(objectInitializer);
    }
}
exports.AnySchema = AnySchema;
class AnyObjectSchema extends schema_1.Schema {
    constructor(description, objectInitializer) {
        super("AnyObject", description, schema_type_1.SchemaType.AnyObject);
        this.apply(objectInitializer);
    }
}
exports.AnyObjectSchema = AnyObjectSchema;
//# sourceMappingURL=any.js.map